import { Button, FilterField, LabelsName, LablesNames, PDFContactDisplayName, PDFDisplayName, PDFOEMDisplayName, PDFVendorDisplayName, PDFVPLDisplayName, PermissonAccess, RoutePath, TabNames, VplOemId } from './../../../shared/model/enum';
import { DeleteCompany, DeleteContactOrCompanyModel, GetAllDropDownModel } from './../companies/pages/companies/companies.model';
import { CrmService } from "./../crm.service";
import { AgGridService } from "./../../../shared/components/ag-grid/ag-grid.service";
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import {
  AssignDropdown,
  RemoveCompanyFilterModel,
} from "../companies/pages/companies/companies.model";
import {
  AgGridPaginationConfig,
  OemExcessPaginationModel,
  PartListPaginationModel,
  SaveUserSetting,
  TablePaginationModel,
  VendorPartLibraryPaginationModel,
} from "../../../shared/components/ag-grid/ag-grid.model";
import { NgbActiveModal, NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { CommonModelPopUpComponent } from "../../../shared/components/common-model-pop-up/common-model-pop-up.component";
import { FooterTitle, Path, PopUpTitles, Url } from "../../../shared/model/enum";
import { ToastrService } from "ngx-toastr";
import { AddCompanyComponent } from "../companies/pop-ups/add-company/add-company.component";
import { AssignComponent } from "../companies/pop-ups/assign/assign.component";
import { DockService } from "../../../shared/components/footer/dock.service";
import { FilterComponent } from "../companies/pop-ups/filter/filter.component";
import { Filters } from "../../../shared/model/filter.model";
import { StorageService } from "../../../shared/services/storage.service";
import { SidebarNotificationService } from "../../../shared/components/sidebar-notification/sidebar-notification.service";
import { TabsService } from '../../../shared/components/tabs/tabs.service';
import { BehaviorSubject, forkJoin, Observable, of, Subscription, timeInterval } from 'rxjs';
import { AddContactComponent } from '../contacts/pop-ups/add-contact/add-contact.component';
import { GridName, UserSetting } from '../crm.model';
import { AddActivityComponent } from '../activity-manager/pop-ups/add-activity/add-activity.component';
import { AddActivitTitle } from '../../../shared/model/common.model';
import { Menu } from '../../../shared/services/nav.service';
import { Router } from '@angular/router';
import { AddRequirementComponent } from '../../sales/requirements/popup/add-requirement/add-requirement.component';
import { ArchivedService } from '../archived-companies/archived-companies.service'
import 'jspdf-autotable';
import { CommonService } from "../../../shared/services/common.service";
import { AddCompanyService } from '../companies/pop-ups/add-company/add-company.service';
import { AddMailingListComponent } from '../companies/pop-ups/add-mailing-list/add-mailing-list.component';
import { AddiconList } from '../../authentication/login/login.model';
import { SendDataService } from '../../../shared/services/send-data.service';
import { ModalPopupSize } from '../../../shared/model/common.model';
import { AddEditPartComponent } from '../../parts-and-inventory/parts-list/popup/add-edit-part/add-edit-part.component';
import { AddEditInventoryComponent } from '../../parts-and-inventory/parts-list/popup/add-edit-inventory/add-edit-inventory.component';
import { AddEditVendorPartComponent } from '../../parts-and-inventory/parts-list/popup/add-edit-vendor-part/add-edit-vendor-part.component';
import { RequestVendorPopupComponent } from '../../parts-and-inventory/parts-list/popup/request-vendor-popup/request-vendor-popup.component';
import { ViewConsignmentComponent } from '../../parts-and-inventory/parts-list/popup/view-consignment/view-consignment.component';
import { AddEditOfferComponent } from '../../parts-and-inventory/parts-list/popup/add-edit-offer/add-edit-offer.component';
import { AddEditConsignmentComponent } from '../../parts-and-inventory/parts-list/popup/add-edit-consignment/add-edit-consignment.component';
import { PartsListService } from '../../parts-and-inventory/parts-list/pages/parts-list/parts-list.service';
import { VendorPartsLibraryService } from '../../parts-and-inventory/vendor-parts-library/pages/vendor-parts-library/vendor-parts-library.service';
import { OemExcessService } from '../../parts-and-inventory/oem-excess/pages/oem-excess/oem-excess.service';
import { LineOEMExcessList, LineVPLStatusList, OEMNewList, OEMRequestList, vplNewList, vplRequestList } from '../crm-api-constants';

@Component({
  selector: "app-crm-common-header",
  templateUrl: "./crm-common-header.component.html",
  styleUrls: ["./crm-common-header.component.scss"],
})
export class CrmCommonHeaderComponent implements OnInit, OnDestroy {
  enumButtonName = Button;
  enumItemLablesNames = LablesNames;
  enumTabNames = TabNames;
  paginationBaseModel = new TablePaginationModel();
  agGridPaginationConfig = new AgGridPaginationConfig();
  // paginationBaseModel= new TablePaginationModel();
  //#region All Input
  @Input() isVisible: boolean;
  @Input() footerIcon: string;
  @Input() footerTitle: string;
  @Input() footerPath: string;
  @Input() buttonName: string
  @Input() buttonImport: string = 'Import';
  @Output() refreshInventoryInfoEvent = new EventEmitter();  // for refresh common parts inventory info
  showlist: boolean = false;
  showNewlist: boolean = false;
  gridInfo: any
  //#endregion
  @ViewChildren('buttonRefs') buttonRefs: any;

  //#region All Output
  filtersFromPopup: string = "";
  //#endregion

  //#region List Declaration
  dropdownData: AssignDropdown[] = [];
  buttonWidths = [];
  dropdownDataList =
    [
      {
        id: "2",
        name: "Leads",
        labelName: "Stage",
        colorCode: null,
        isActive: false,
      },
      {
        id: "3",
        name: "Prospects",
        labelName: "Stage",
        colorCode: null,
        isActive: false,
      },
      {
        id: "1",
        name: "Customers",
        labelName: "Stage",
        colorCode: null,
        isActive: false,
      },
    ]
  //#endregion

  //#region model Declaration
  //#endregion
  getSiebarValues: any;
  active = false;
  @Input() pinned: boolean = false;
  enumPopUpTitles = PopUpTitles;
  companyName: string[] = [];
  contactName: string[] = [];
  vendorContactName: string[] = [];
  contactReycleBin: string[] = [];
  companyID: any[] = [];
  contactID: any[] = [];
  sendCompanyID: string[] = [];
  sendContactID: string[] = [];
  base64: any;
  file: Blob;
  fileName: string;
  enumUrl = Url;
  enumPath = Path;
  enumFooterTitle = FooterTitle;
  stagesName: string;
  selectFilterOptionlist: any[] = [];
  expanded1: boolean = false;
  isDropDown = false;
  id: number;
  isLoading: boolean = false;
  buttonSum = 0
  addToIndex = 0
  removeCompanyFilterModel = new RemoveCompanyFilterModel();
  // @ViewChild("mySelect", { static: true }) mySelect: ElementRef;
  @ViewChild("mySelect") mySelect: ElementRef;
  selectedData: any[] = [];
  selectedRequirementData: any[] = [];
  isButtonDisabled: boolean = false;
  companyGridApi: any;
  companyColumnApi: any;
  //filter show variables//
  @ViewChild('fileterButton') fileterButton: ElementRef;
  headerData: any
  show: any;
  toggle: boolean = false;
  showValfirst: any;
  arr: any[] = [];
  downArrow: string = "./assets/SVGIcons/downarrow.svg";
  upArrow: string = "./assets/SVGIcons/uparrow.svg";
  currentTab = ''
  width: number
  isSideBarOpend = false
  screenWidth$ = new BehaviorSubject<number>(window.innerWidth);
  count = 0;
  valueGet = 0;
  finalShow: number;
  bigShow: number
  enumFilterLabel = LabelsName;
  getAllDropDownModel = new GetAllDropDownModel();
  deleteContactModel = new DeleteContactOrCompanyModel();
  deleteCompanyModel = new DeleteCompany();
  enumAddActivitTitle = AddActivitTitle;
  userSetting = new UserSetting();
  allUserSettings: any
  saveUserSetting = new SaveUserSetting();
  enumPermissonAccess = PermissonAccess
  switchSubscription: Subscription;
  starSubscription: Subscription;
  stringArrayCompanyID = [];
  stringArrayContactID = [];
  ////////////////////
  testingArr = [
    'Companies.Can.View.Company',
    'Companies.Can.View.All.Companies',
    'Companies.Can.Add.Company',
    'Companies.Can.Edit.Company',
    'Companies.Can.Delete.Company'
  ];
  assign_Button: boolean;
  delete_Button: boolean;
  add_Contact_Button: boolean;
  add_Company_Button: boolean;
  add_Task_Button: boolean;
  send_Email_Button: boolean;
  archive_Button: boolean;
  import_Companies_Button: boolean;
  userID: any;
  // defaultColumns = DisplayName;
  defaultColumns = PDFContactDisplayName;
  defaultColumns1 = PDFDisplayName;
  defaultColumns2 = PDFVendorDisplayName;
  defaultColumnsVPL = PDFVPLDisplayName;
  defaultColumnsOEM = PDFOEMDisplayName;
  route;
  routerPath = RoutePath
  getAllPartDropdown: any = {}
  partListPaginationModel = new PartListPaginationModel();
  vplPaginationModel = new VendorPartLibraryPaginationModel()
  oemPaginationModel = new OemExcessPaginationModel();
  dropDownOpen: string | null;
  LineStatusList = LineVPLStatusList
  LineOEMExcessList = LineOEMExcessList
  OemNewList = OEMNewList
  VplNewList = vplNewList
  vplRequestList = vplRequestList
  RequestList = OEMRequestList
  showImportSubmenu = false;
  showNewSubmenu = false;
  /////////////////////
  constructor(
    public agGridService: AgGridService,
    public modalService: NgbModal,
    public crmService: CrmService,
    private toastr: ToastrService,
    private dockService: DockService,
    private elRef: ElementRef,
    private sidebarNotificationService: SidebarNotificationService,
    public storage: StorageService,
    public tabsService: TabsService,
    private router: Router,
    public archivedService: ArchivedService,
    public commonService: CommonService,
    public companiesService: AddCompanyService,
    public sendDataService: SendDataService,
    public partsListService: PartsListService,
    public vplService: VendorPartsLibraryService,
    public oemExcessService: OemExcessService
  ) {

    this.sidebarNotificationService.isSidebarNotificationShow.subscribe(res => {
      if (res != undefined) {
        // this.show = this.valueGet;
        this.getSiebarValues = res.bool;
        if (res.bool === true) {
        }
        this.isSideBarOpend = res.bool
        this.show = this.selectFilterOptionlist.length;

        this.ngAfterView()
      }

    })

    this.getScreenWidth().subscribe((res) => {
      this.width = res;
    });

  }

  @HostListener("window:resize", ["$event"])
  onResize(event: { target: { innerWidth: number } }) {
    this.show = this.selectFilterOptionlist.length;
    this.addToIndex = 1;
    this.width = event.target.innerWidth;
    this.ngAfterView()
  }
  getScreenWidth(): Observable<number> {
    return this.screenWidth$.asObservable();
  }

  @HostListener("document:click", ["$event.target"])
  onClickOutside(target: HTMLElement) {
    if (!this.mySelect?.nativeElement?.contains(target)) {
      this.active = false;
    }
  }

  formatTooltipLabel(labelName: string): string {
    switch (labelName) {
      case "excludedFromVendorlist":
        // return "Excluded From Vendor List";
        return this.route == this.routerPath.COMPANY_ROUTEPATH ? "Include Excluded" : "Excluded From Vendor List";
      case "AVL":
        return "AVL";
      case "NAVL":
        return "Non AVL";
      case "startRating":
        return "Start Rating";
      case "endRating":
        return "End Rating";
      case "fromDate":
        return "From Date";
      case "toDate":
        return "To Date";
      case "Contacted Date":
        return "Date Contacted";
      case "SICCode":
        return "SIC Code";
      case "NAICS Code":
        return "NAICS Code";
      default:
        // Split the label name by uppercase letters
        // const words = labelName.split(/(?=[A-Z])/);

        // // Add space between words and convert to lowercase
        // const formattedName = words.map(word => word.toLowerCase()).join(' ');

        // // Convert the first letter of each word to uppercase
        // return formattedName.charAt(0).toUpperCase() + formattedName.slice(1);
        return labelName;
    }
  }


  downloadPDF() {
    const header = this.getHeaderAndData().header;
    const data = this.getHeaderAndData().data;
    const titleMap: { [key: string]: string } = {
      'contacts': 'contacts PDF',
      'vendor-contact': 'vendor-contact PDF',
      'vendor-list': 'vendor-list PDF',
      'vendor-parts-library': 'vendor-parts-library PDF',
      'oem-excess': 'oem-excess PDF'
    };
    const title = titleMap[this.currentTab] || 'company PDF';
    this.commonService.generatePdfAndPrint(data, header, title);
  }

  getHeaderAndData(): { header: any[], data: any[] } {
    const nodes = this.companyGridApi?.api?.getRenderedNodes()
    const data = nodes.map((x) => x.data);

    const getColumns = this.companyColumnApi.getColumns();
    const columns = getColumns.map((x) => ({
      title: x.colDef.headerName,
      name: x.colDef.field,
    }))
    const defaultColumsList: any = []
    switch (this.currentTab) {
      case 'contacts':
      case 'vendor-contact':
        for (let item in this.defaultColumns) {
          defaultColumsList.push(this.defaultColumns[item])
        }
        break;
      case 'vendor-list':
        for (let item in this.defaultColumns2) {
          defaultColumsList.push(this.defaultColumns2[item])
        }
        break;
      case 'vendor-parts-library':
        for (let item in this.defaultColumnsVPL) {
          defaultColumsList.push(this.defaultColumnsVPL[item])
        }
        break;
      case 'oem-excess':
        for (let item in this.defaultColumnsOEM) {
          defaultColumsList.push(this.defaultColumnsOEM[item])
        }
        break;

      default:
        for (let item in this.defaultColumns1) {
          defaultColumsList.push(this.defaultColumns1[item])
        }
        break
    }
    const defalutColumnsList = columns.filter((x) => defaultColumsList.some((y) => x.title == y));
    return { header: defalutColumnsList, data: data }
  }

  downLoadExcel() {
    const columns = this.getHeaderAndData().header;
    const data = this.getHeaderAndData().data;
    const headData = [columns?.map(column => column?.title)];
    const bodyData = data?.map(row => columns?.map(column => row[column?.name]));
    const titleMap: { [key: string]: string } = {
      'contacts': 'contacts.xlsx',
      'vendor-contact': 'vendor-contact.xlsx',
      'vendor-list': 'vendor-list.xlsx',
      'vendor-parts-library': 'vendor-parts-library.xlsx',
      'oem-excess': 'oem-excess.xlsx'
    };
    const title = titleMap[this.currentTab] || 'company.xlsx';

    this.commonService.export(headData, bodyData, title);
  }
  mfrDropdownList() {
    if (this.router.url == RoutePath.PARTLIST_ROUTEPATH || this.router.url.includes(this.routerPath.PARTLISTINFO_ROUTEPATH))
      this.partListPaginationModel = this.storage.retrieve(GridName.AG_GRID_PARTLIST_PAGINATIONMODEL) ?? this.partListPaginationModel
    if (this.router.url == this.routerPath.VENDOR_PARTS_LIBRARY)
      this.vplPaginationModel = this.storage.retrieve(GridName.AG_GRID_VPL_PAGINATIONMODEL) ?? this.vplPaginationModel
    if (this.router.url == this.routerPath.OEM_EXCESS)
      this.oemPaginationModel = this.storage.retrieve(GridName?.AG_GRID_OEM_PAGINATIONMODEL) ?? this.oemPaginationModel
    this.partsListService.getAllPartDropdown().subscribe((res => {
      if (res.isSuccess) {
        this.getAllPartDropdown = res?.response;
      }
    }))
  }
  onSelectId(event) {
    this.storage.store(GridName.AG_GRID_PARTLIST_PAGINATIONMODEL, this.partListPaginationModel)
    if (this.router.url == this.routerPath.VENDOR_PARTS_LIBRARY) {
      this.storage.store(GridName.AG_GRID_VPL_PAGINATIONMODEL, this.vplPaginationModel)
    }
    else if (this.router.url == this.routerPath.OEM_EXCESS) {
      this.storage.store(GridName.AG_GRID_OEM_PAGINATIONMODEL, this.oemPaginationModel)
    }
    this.paginationBaseModel.pageNumber = 1
    this.agGridService.setPaginationData(this.paginationBaseModel);
  }
  ngOnInit(): void {
    this.mfrDropdownList()
    this.route = this.router.url
    this.agGridService.gridApi.subscribe((res) => {
      if (res) {
        this.companyGridApi = res;
      }

    })

    this.agGridService.gridColumnApi.subscribe((res) => {
      if (res) {
        this.companyColumnApi = res;
      }
    })

    this.userID = this.storage.retrieve('userId')

    let isActiveTrue = false
    let isStar = false
    this.crmService.isRating.subscribe(res => {
      isStar = res

    }
    )
    this.starSubscription = this.agGridService.ratingChanged.subscribe(res => {
      if (isStar) {
        this.changeTableData()
      }
    })
    this.crmService.isActive.subscribe(res => {
      isActiveTrue = res
    })
    this.switchSubscription = this.crmService.swichChanged.subscribe(res => {
      this.crmService.swichChanged.observed
      if (isActiveTrue) {
        this.changeTableData()
      }
    })
    this.crmService.getAllFilterDropDownList().subscribe((res) => {
      this.getAllDropDownModel = res?.response;
    })

    this.crmService.getAllFilterDropDownList().subscribe((res) => {
      this.crmService.dropdownAllList.next(res.response);
    });
    this.pinned =
      this.dockService?.pinnedlist?.find((a) => a?.path == this.footerPath)
        ?.pinned ?? false;
    if (!this.pinned) {
      this.getPinnedValue()
    }
    this.accountTypeDropdown();
    this.initDatatable();
    this.ngAfterView()


    this.agGridService.selectionChanged.subscribe((res) => {
      if (res) {
        this.gridInfo = res;
        const ress: any = res;
        // this.selectedData = this.agGridService.getGridApi().getSelectedRows();
        this.selectedData = ress?.api?.getSelectedRows();
        this.companyName = this.selectedData?.map((items) => { return items.vendorName || items.companyName; });
        this.contactName = this.selectedData?.map((items) => { return items.contactFullName });
        this.vendorContactName = this.selectedData?.map((items) => { return items.fullName });
        this.contactReycleBin = this.selectedData?.map((items) => { return items.contactName });
        this.companyID = this.selectedData?.map((items) => { return items.id; });
        this.contactID = this.selectedData?.map((items) => { return items.id; });
        if (this.currentTab === 'vendor-contact' || this.currentTab === 'contacts') {
          this.stringArrayContactID = Array?.from(this.contactID ?? [], num => num?.toString());
        } else {
          this.stringArrayCompanyID = Array?.from(this.companyID ?? [], num => num?.toString());
        }
      }
    });
    this.tabsService.currentTab.subscribe(res => {
      if (res) {
        res = res?.substring(res?.lastIndexOf('/') + 1);
        this.currentTab = res
      } else {
        this.currentTab = this.tabsService.thisTab
      }
    })
    this.getCompanyFilter();
    this.changePermissionByTab();

  }


  changePermissionByTab() {
    if (this.currentTab == this.enumTabNames.COMPANIES) {
      this.add_Company_Button = this.testingArr.includes(this.enumPermissonAccess.CAN_ADD_COMPANY)
    }
    if (this.currentTab == this.enumTabNames.LEADS) {

    }
    if (this.currentTab == this.enumTabNames.CUSTOMERS) {

    }
    if (this.currentTab == this.enumTabNames.PROSPECTS) {

    }
    if (this.currentTab == this.enumTabNames.CONTACTS) {
      this.add_Company_Button = this.testingArr.includes(this.enumPermissonAccess.CAN_ADD_COMPANY)
    }
  }
  //#region getStageDropDownData

  initDatatable() {
    this.paginationBaseModel = {
      sortColumn: "",
      sortDirection: "",
      pageNumber: this.agGridPaginationConfig.currentPageNumber,
      pageSize: this.agGridPaginationConfig.pageSize,
      searchText: this.agGridPaginationConfig.searchText,
      getAll: this.agGridPaginationConfig.pageSize == 1 ? true : false,
      id: this.paginationBaseModel.id,
      isActive: this.paginationBaseModel.isActive,
      stage: this.agGridService.getStage(),
      companyId: '',
      categoryId: '0',
      companyOrVendorId: '',
      documentTypeId: 0,
      filters: "",
      selectedId: [],
      exportAsPdf: true,
      //  filtersFromPopup: this.agGridService.getFilter(),
      filtersFromPopup: "",
      searchCompanyText: this.paginationBaseModel.searchCompanyText,
    };
    this.agGridService.setPaginationData(this.paginationBaseModel);
    this.stagesName = this.paginationBaseModel.stage;
  }
  getPinnedValue() {
    this.crmService.getUserSetting()
      .subscribe(res => {
        if (res?.isSuccess) {
          // let json = JSON.parse(res?.response?.userSetting) ?? {}
          let json = JSON.parse(res?.response) ?? {}

          this.pinned =
            json.pinnedValues?.find((a) => a?.path == this.footerPath)
              ?.pinned ?? false;

          if (json.pinnedValues && !this.dockService.pinnedlist) {
            this.storage.store('pinnedValues', json.pinnedValues)
            this.dockService.pinnedlist = json.pinnedValues
          }
        }
      })
  }
  accountTypeDropdown() {
    this.agGridService.accountTypeSelectDropdown().subscribe((res) => {
      if (res.isSuccess == true) {
        this.dropdownData = res?.response?.stageList;

      }
    });
  }

  //#endregion
  currentSelection: string = 'All';
  setCurrentSelection(option: any, id: any): void {
    this.currentSelection = option;
    this.paginationBaseModel.stage = id;
    this.agGridService.setStage(id);
    this.agGridService.setPaginationData(this.paginationBaseModel);

  }

  getCompanyDataByStageValue() {
    this.agGridService.setPaginationData(this.paginationBaseModel);
  }

  searchTextFilter(searchText) {
    this.paginationBaseModel.pageNumber = 1
    this.agGridService.setPaginationData(this.paginationBaseModel);
  }

  OpenFilterModal() {
    if (!this.isButtonDisabled) {
      this.isButtonDisabled = true;

      const dropdownApi1 = this.crmService.getAllFilterDropDownList();


      forkJoin([dropdownApi1]).subscribe(
        ([res1]) => {
          this.getAllDropDownModel = res1?.response;
          const modalOption: NgbModalOptions = {
            centered: true,
            backdrop: 'static',
            keyboard: false,
            windowClass: 'filterCompanyPopUP',
          };

          setTimeout(() => {
            const modalRef = this.modalService.open(FilterComponent, modalOption);

            modalRef.componentInstance.stagesName = this.paginationBaseModel.stage;
            modalRef.componentInstance.getAllDropDownModel = this.getAllDropDownModel;
            if (this.route == this.routerPath.VENDOR_PARTS_LIBRARY || this.route == this.routerPath.OEM_EXCESS || this.route == this.routerPath.PARTLIST_ROUTEPATH) {
              modalRef.componentInstance.vendorPartLibraryFilters = true;
              if (this.route == this.routerPath.VENDOR_PARTS_LIBRARY || this.route == this.routerPath.OEM_EXCESS)
                modalRef.componentInstance.getAllDropDownModel.manufacturerList = this.getAllDropDownModel.masterManufacturerWithChildrenList;
            }
            modalRef.result.then((result) => {
              this.isButtonDisabled = false;
              if (result) {
                this.getCompanyFilter();
              }
            });
          }, 10);
        },
        (error) => {
          console.error('API call failed', error);
          this.isButtonDisabled = false;
        }
      );
    }
  }

  getDataFromStorage() {
    let grids = this.storage.retrieve("userSetting")
    // stored grids
    this.userSetting.companies = grids.companies;
    this.userSetting.contacts = grids.contacts;
    this.userSetting.customers = grids.customers;
    this.userSetting.leads = grids.leads;
    this.userSetting.prospects = grids.prospects;
    this.userSetting.vendorLists = grids.VendorList;
    this.userSetting.vendorContacts = grids.vendorContact;
    this.userSetting.requirementLists = grids.requirements;
    this.userSetting.partlistFilter = grids.partlistFilter;
    this.userSetting.vendorPartLibraryFilter = grids.vendorPartLibraryFilter;
    this.userSetting.oemExcessManagerFilter = grids.oemExcessManagerFilter;

    // stored filter
    this.userSetting.companiesFilter = this.storage.retrieve(this.enumTabNames.COMPANIES_FILTERS)
    this.userSetting.contactFilter = this.storage.retrieve(this.enumTabNames.CONTACTS_FILTERS)
    this.userSetting.customersFilters = this.storage.retrieve(this.enumTabNames.CUSTOMERS_FILTERS)
    this.userSetting.leadsFilter = this.storage.retrieve(this.enumTabNames.LEADS_FILTERS)
    this.userSetting.prospectsFilter = this.storage.retrieve(this.enumTabNames.PROSPECTS_FILTERS)
    this.userSetting.vendorListFilters = this.storage.retrieve(this.enumTabNames.VENDORLIST_FILTERS)
    this.userSetting.vendorContactsFilter = this.storage.retrieve(this.enumTabNames.VENDORCONTACT_FILTERS);
    this.userSetting.requirementsFilter = this.storage.retrieve(this.enumTabNames.REQUIREMENTS_FILTERS);
    this.userSetting.partlistFilter = this.storage.retrieve(this.enumTabNames.PARTLIST_FILTERS);
    this.userSetting.vendorPartLibraryFilter = this.storage.retrieve(this.enumTabNames.VENDORPARTLIBRAY_FILTERS);
    this.userSetting.oemExcessManagerFilter = this.storage.retrieve(this.enumTabNames.OEMEXCESSMANAGER_FILTERS);

    this.saveUserSetting.userSetting = JSON.stringify(this.userSetting);
    this.agGridService.saveUserSetting(this.saveUserSetting).subscribe(res => {
      const json = JSON.parse(res?.response);
      this.storage.store("userSetting", json)
    })
  }

  getUserSettings() {
    let value: any
    this.crmService.getUserSetting()
      .subscribe(res => {
        this.agGridService.tablePaginationData.next(undefined)
        if (res?.isSuccess) {
          // let json = JSON.parse(res?.response?.userSetting) ?? {}
          let json = JSON.parse(res?.response) ?? {}

          // let json =  new UserSetting();

          this.storage.store("userSetting", json);
          if (this.currentTab == this.enumTabNames.COMPANIES) {
            let companies = this.storage.retrieve(this.enumTabNames.COMPANIES_FILTERS);
            companies = companies && companies.companyFilterList ? companies : undefined
            if (companies == undefined && json.companiesFilter) {
              this.storage.store(this.enumTabNames.COMPANIES_FILTERS, json.companiesFilter)
              value = json.companiesFilter
              this.selectFilterOptionlist = json.companiesFilter?.companyFilterResponse ?? [];
              this.applyFilter(json.companiesFilter?.companyFilterList);
              this.ngAfterView();
              this.changeTableData()
            }
          }
          if (this.currentTab == this.enumTabNames.LEADS) {
            let leads = this.storage.retrieve(this.enumTabNames.LEADS_FILTERS);
            leads = leads && leads.companyFilterList ? leads : undefined
            if (leads == undefined && json.leadsFilter) {
              this.storage.store(this.enumTabNames.LEADS_FILTERS, json.leadsFilter)
              this.selectFilterOptionlist = json.leadsFilter?.companyFilterResponse ?? [];
              this.applyFilter(json.leadsFilter?.companyFilterList);
              this.ngAfterView();
              this.changeTableData()
            }
          }
          if (this.currentTab == this.enumTabNames.CUSTOMERS) {
            let customer = this.storage.retrieve(this.enumTabNames.CUSTOMERS_FILTERS);
            customer = customer && customer.companyFilterList ? customer : undefined
            if (customer == undefined && json.customersFilters) {
              this.storage.store(this.enumTabNames.CUSTOMERS_FILTERS, json.customersFilters)
              this.selectFilterOptionlist = json.customersFilters?.companyFilterResponse ?? [];
              this.applyFilter(json.customersFilters?.companyFilterList);
              this.ngAfterView();
              this.changeTableData()
            }
          }
          if (this.currentTab == this.enumTabNames.PROSPECTS) {
            let prospect = this.storage.retrieve(this.enumTabNames.PROSPECTS_FILTERS);
            prospect = prospect && prospect.companyFilterList ? prospect : undefined
            if (prospect == undefined && json.prospectsFilter) {
              this.storage.store(this.enumTabNames.PROSPECTS_FILTERS, json.prospectsFilter)
              this.selectFilterOptionlist = json.prospectsFilter?.companyFilterResponse ?? [];
              this.applyFilter(json.prospectsFilter?.companyFilterList);
              this.ngAfterView();
              this.changeTableData()
            }
          }
          if (this.currentTab == this.enumTabNames.CONTACTS) {
            let contact = this.storage.retrieve(this.enumTabNames.CONTACTS_FILTERS);
            contact = contact && contact.companyFilterList ? contact : undefined
            if (contact == undefined && json?.contactFilter) {
              this.storage.store(this.enumTabNames.CONTACTS_FILTERS, json.contactFilter)
              this.selectFilterOptionlist = json.contactFilter?.companyFilterResponse ?? [];
              this.applyFilter(json.contactFilter?.companyFilterList);
              this.ngAfterView();
              this.changeTableData()
            }
          }
          if (this.currentTab == this.enumTabNames.VENDOR_LIST) {
            let vendorList = this.storage.retrieve(this.enumTabNames.VENDORLIST_FILTERS);
            vendorList = vendorList && vendorList.companyFilterList ? vendorList : undefined
            if (vendorList == undefined && json?.vendorListFilters) {
              this.storage.store(this.enumTabNames.VENDORLIST_FILTERS, json.vendorListFilters)
              this.selectFilterOptionlist = json.vendorListFilters?.companyFilterResponse ?? [];
              this.applyFilter(json.vendorListFilters?.companyFilterList);
              this.ngAfterView();
              this.changeTableData()
            }
          }
          if (this.currentTab == this.enumTabNames.VENDOR_CONTACT) {
            let vendorContact = this.storage.retrieve(this.enumTabNames.VENDORCONTACT_FILTERS);
            vendorContact = vendorContact && vendorContact.companyFilterList ? vendorContact : undefined
            if (vendorContact == undefined && json?.vendorContactsFilter) {
              this.storage.store(this.enumTabNames.VENDORCONTACT_FILTERS, json.vendorContactsFilter)
              this.selectFilterOptionlist = json.vendorContactsFilter?.companyFilterResponse ?? [];
              this.applyFilter(json.vendorContactsFilter?.companyFilterList);
              this.ngAfterView();
              this.changeTableData()
            }
          }
          if (this.currentTab == this.enumTabNames.REQUIREMENTS) {
            let procurement = this.storage.retrieve(this.enumTabNames.REQUIREMENTS_FILTERS);
            procurement = procurement && procurement.companyFilterList ? procurement : undefined
            if (procurement == undefined && json?.requirementsFilter) {
              this.storage.store(this.enumTabNames.REQUIREMENTS_FILTERS, json.requirementsFilter)
              this.selectFilterOptionlist = json.requirementsFilter?.companyFilterResponse ?? [];
              this.applyFilter(json.requirementsFilter?.companyFilterList);
              this.ngAfterView();
              this.changeTableData()
            }
          }

          if (this.currentTab == this.enumTabNames.PARTLIST) {
            let partandinventory = this.storage.retrieve(this.enumTabNames.PARTLIST_FILTERS);
            partandinventory = partandinventory && partandinventory.companyFilterList ? partandinventory : undefined
            if (partandinventory == undefined && json?.partlistFilter) {
              this.storage.store(this.enumTabNames.PARTLIST_FILTERS, json.partlistFilter)
              this.selectFilterOptionlist = json.partlistFilter?.companyFilterResponse ?? [];
              this.applyFilter(json.partlistFilter?.companyFilterList);
              this.ngAfterView();
              this.changeTableData()
            }
          }
          if (this.currentTab == this.enumTabNames.VENDOR_PART_LIBRAY) {
            let vplData = this.storage.retrieve(this.enumTabNames.VENDORPARTLIBRAY_FILTERS);
            vplData = vplData && vplData.companyFilterList ? vplData : undefined
            if (vplData == undefined && json?.vendorPartLibraryFilter) {
              this.storage.store(this.enumTabNames.VENDORPARTLIBRAY_FILTERS, json.vendorPartLibraryFilter)
              this.selectFilterOptionlist = json.vendorPartLibraryFilter?.companyFilterResponse ?? [];
              this.applyFilter(json.vendorPartLibraryFilter?.companyFilterList);
              this.ngAfterView();
              this.changeTableData()
            }
          }
          if (this.currentTab == this.enumTabNames.OEM_EXCESS_MANAGER) {
            let oemExcessData = this.storage.retrieve(this.enumTabNames.OEMEXCESSMANAGER_FILTERS);
            oemExcessData = oemExcessData && oemExcessData.companyFilterList ? oemExcessData : undefined
            if (oemExcessData == undefined && json?.oemExcessManagerFilter) {
              this.storage.store(this.enumTabNames.OEMEXCESSMANAGER_FILTERS, json.oemExcessManagerFilter)
              this.selectFilterOptionlist = json.oemExcessManagerFilter?.companyFilterResponse ?? [];
              this.applyFilter(json.oemExcessManagerFilter?.companyFilterList);
              this.ngAfterView();
              this.changeTableData()
            }
          }
          // else{
          //   this.initDatatable();
          // }

        }

        else {
          this.storage.store("userSetting", {})
        }

      });

  }

  getCompanyFilter1() {
    let value = this.storage.retrieve("filters");
    if (this.currentTab == this.enumTabNames.COMPANIES) {
      value = this.storage.retrieve(this.enumTabNames.COMPANIES);
      value = value && value.companyFilterList ? value : undefined
      if (value == undefined) {
        this.getUserSettings()
      }
    }
    if (this.currentTab == this.enumTabNames.LEADS) {
      value = this.storage.retrieve(this.enumTabNames.LEADS);
      value = value && value.companyFilterList ? value : undefined
      if (value == undefined) {
        this.getUserSettings()
      }
    }
    if (this.currentTab == this.enumTabNames.CUSTOMERS) {
      value = this.storage.retrieve(this.enumTabNames.CUSTOMERS);
      value = value && value.companyFilterList ? value : undefined
      if (value == undefined) {
        this.getUserSettings()
      }
    }
    if (this.currentTab == this.enumTabNames.PROSPECTS) {
      value = this.storage.retrieve(this.enumTabNames.PROSPECTS);
      value = value && value.companyFilterList ? value : undefined
      if (value == undefined) {
        this.getUserSettings()
      }
    }
    if (this.currentTab == this.enumTabNames.CONTACTS) {
      value = this.storage.retrieve(this.enumTabNames.CONTACTS);
      value = value && value.companyFilterList ? value : undefined
      if (value == undefined) {
        this.getUserSettings()
      }
    }
    if (this.currentTab == this.enumTabNames.VENDOR_LIST) {

      value = this.storage.retrieve("vendorList");
      value = value && value.companyFilterList ? value : undefined

      if (value == undefined) {
        this.getUserSettings()
      }
    }
    if (this.currentTab == this.enumTabNames.VENDOR_CONTACT) {
      value = this.storage.retrieve("vendorContact");
      value = value && value.companyFilterList ? value : undefined

      if (value == undefined) {
        this.getUserSettings()
      }
    }
    if (this.currentTab == this.enumTabNames.CONTACT_RECYCLEBIN) {
      value = this.storage.retrieve(this.enumTabNames.CONTACT_RECYCLEBIN);
      if (value == undefined) {
        this.getUserSettings()
      }
    } if (this.currentTab == this.enumTabNames.COMPANY_RECYCLEBIN) {
      value = this.storage.retrieve(this.enumTabNames.COMPANY_RECYCLEBIN);
      value = value && value.companyFilterList ? value : undefined
      if (value == undefined) {
        this.getUserSettings()
      }
    }
    if (this.currentTab == this.enumTabNames.REQUIREMENTS) {
      value = this.storage.retrieve(this.enumTabNames.REQUIREMENTS);
      value = value && value.companyFilterList ? value : undefined
      if (value == undefined) {
        this.getUserSettings()
      }
    }

    if (this.currentTab == this.enumTabNames.PARTLIST) {
      value = this.storage.retrieve(this.enumTabNames.PARTLIST);
      value = value && value.companyFilterList ? value : undefined
      if (value == undefined) {
        this.getUserSettings()
      }
    }
    if (this.currentTab == this.enumTabNames.VENDOR_PART_LIBRAY) {
      value = this.storage.retrieve(this.enumTabNames.VENDOR_PART_LIBRAY);
      value = value && value.companyFilterList ? value : undefined
      if (value == undefined) {
        this.getUserSettings()
      }
    }
    if (this.currentTab == this.enumTabNames.OEM_EXCESS_MANAGER) {
      value = this.storage.retrieve(this.enumTabNames.OEM_EXCESS_MANAGER);
      value = value && value.companyFilterList ? value : undefined
      if (value == undefined) {
        this.getUserSettings()
      }
    }
    // this.getDataFromStorage()
    this.filtersFromPopup = "";

    this.selectFilterOptionlist = value?.companyFilterResponse ?? [];
    this.applyFilter(value?.companyFilterList);
    this.ngAfterView();
    this.changeTableData()
  }
  getCompanyFilter() {
    let value = this.storage.retrieve("filters");

    switch (this.currentTab) {
      case this.enumTabNames.COMPANIES:
        value = this.storage.retrieve(this.enumTabNames.COMPANIES_FILTERS);
        break;
      case this.enumTabNames.LEADS:
        value = this.storage.retrieve(this.enumTabNames.LEADS_FILTERS);
        break;
      case this.enumTabNames.CUSTOMERS:
        value = this.storage.retrieve(this.enumTabNames.CUSTOMERS_FILTERS);
        break;
      case this.enumTabNames.PROSPECTS:
        value = this.storage.retrieve(this.enumTabNames.PROSPECTS_FILTERS);
        break;
      case this.enumTabNames.CONTACTS:
        value = this.storage.retrieve(this.enumTabNames.CONTACTS_FILTERS);
        break;
      case this.enumTabNames.VENDOR_LIST:
        value = this.storage.retrieve(this.enumTabNames.VENDORLIST_FILTERS);
        break;
      case this.enumTabNames.VENDOR_CONTACT:
        value = this.storage.retrieve(this.enumTabNames.VENDORCONTACT_FILTERS);
        break;
      case this.enumTabNames.PARTLIST:
        value = this.storage.retrieve(this.enumTabNames.PARTLIST_FILTERS);
        break;
      case this.enumTabNames.REQUIREMENTS:
        value = this.storage.retrieve(this.enumTabNames.REQUIREMENTS_FILTERS);
        break;
      case this.enumTabNames.VENDOR_PART_LIBRAY:
        value = this.storage.retrieve(this.enumTabNames.VENDORPARTLIBRAY_FILTERS);
        break;
      case this.enumTabNames.OEM_EXCESS_MANAGER:
        value = this.storage.retrieve(this.enumTabNames.OEMEXCESSMANAGER_FILTERS);
        break;

      default:
        value = undefined;
    }
    value = value && value.companyFilterList ? value : undefined;
    if (value == undefined) {
      this.getUserSettings();
      return;
    }

    // Handle the case when filters exist
    this.filtersFromPopup = "";
    this.selectFilterOptionlist = value?.companyFilterResponse ?? [];
    this.applyFilter(value?.companyFilterList);
    this.ngAfterView();
    this.changeTableData();
  }

  updateClearFilter() {
    let value = this.storage.retrieve("filters");
    if (this.currentTab == this.enumTabNames.COMPANIES) {
      value = this.storage.retrieve(this.enumTabNames.COMPANIES_FILTERS);
    }
    if (this.currentTab == this.enumTabNames.LEADS) {
      value = this.storage.retrieve(this.enumTabNames.LEADS_FILTERS);
    }
    if (this.currentTab == this.enumTabNames.CUSTOMERS) {
      value = this.storage.retrieve(this.enumTabNames.CUSTOMERS_FILTERS);
    }
    if (this.currentTab == this.enumTabNames.PROSPECTS) {
      value = this.storage.retrieve(this.enumTabNames.PROSPECTS_FILTERS);
    }
    if (this.currentTab == this.enumTabNames.CONTACTS) {
      value = this.storage.retrieve(this.enumTabNames.CONTACTS_FILTERS);
    }
    if (this.currentTab == this.enumTabNames.VENDOR_LIST) {
      value = this.storage.retrieve(this.enumTabNames.VENDORLIST_FILTERS)
    }
    if (this.currentTab == this.enumTabNames.VENDOR_CONTACT) {
      value = this.storage.retrieve(this.enumTabNames.VENDORCONTACT_FILTERS)
    }
    if (this.currentTab == this.enumTabNames.REQUIREMENTS) {
      value = this.storage.retrieve(this.enumTabNames.REQUIREMENTS_FILTERS)
    }
    if (this.currentTab == this.enumTabNames.PARTLIST) {
      value = this.storage.retrieve(this.enumTabNames.PARTLIST_FILTERS)
    }
    if (this.currentTab == this.enumTabNames.VENDOR_PART_LIBRAY) {
      value = this.storage.retrieve(this.enumTabNames.VENDORPARTLIBRAY_FILTERS)
    }
    if (this.currentTab == this.enumTabNames.OEM_EXCESS_MANAGER) {
      value = this.storage.retrieve(this.enumTabNames.OEMEXCESSMANAGER_FILTERS)
    }

    // this.getDataFromStorage()
    this.filtersFromPopup = "";

    this.selectFilterOptionlist = value?.companyFilterResponse ?? [];
    this.applyFilter(value?.companyFilterList);
    this.ngAfterView();
    this.changeTableData()
  }

  changeTableData() {
    //  this.agGridService.setPaginationData(this.paginationBaseModel);
    this.agGridService.tablePaginationData.next(this.paginationBaseModel)
  }
  applyFilter(data: any): void {
    let filters = new Filters();
    const filterFields: FilterField[] = Object.values(FilterField);

    for (const field of filterFields) {
      filters = this.crmService.modifyFilter(filters, data?.[field], field, 'eq');
    }

    const filtersString = JSON.stringify(filters);
    this.filtersFromPopup = filtersString === '{"rules":[],"groups":[]}' ? '' : filtersString;
    this.paginationBaseModel.filtersFromPopup = this.filtersFromPopup;
    this.paginationBaseModel.pageNumber = 1
    this.agGridService.setFilter(this.filtersFromPopup);
  }


  removeFilterTab(item): void {
    if (item.labelName == this.enumItemLablesNames.RATING) {
      this.crmService.isRating.next(false)
    }
    if (item.lableName == this.enumItemLablesNames.ACTIVE || item.lableName == this.enumItemLablesNames.INACTIVE) {
      this.crmService.isActive.next(false)
    }
    this.removeCompanyFilterModel = item;
    let storeData
    if (this.currentTab == this.enumTabNames.COMPANIES) {
      storeData = this.storage.retrieve(this.enumTabNames.COMPANIES_FILTERS);
    }
    if (this.currentTab == this.enumTabNames.LEADS) {
      storeData = this.storage.retrieve(this.enumTabNames.LEADS_FILTERS);
    }
    if (this.currentTab == this.enumTabNames.CUSTOMERS) {
      storeData = this.storage.retrieve(this.enumTabNames.CUSTOMERS_FILTERS);
    }
    if (this.currentTab == this.enumTabNames.PROSPECTS) {
      storeData = this.storage.retrieve(this.enumTabNames.PROSPECTS_FILTERS);
    }
    if (this.currentTab == this.enumTabNames.CONTACTS) {
      storeData = this.storage.retrieve(this.enumTabNames.CONTACTS_FILTERS);
    }
    if (this.currentTab == this.enumTabNames.VENDOR_LIST) {
      storeData = this.storage.retrieve(this.enumTabNames.VENDORLIST_FILTERS);
    }
    if (this.currentTab == this.enumTabNames.VENDOR_CONTACT) {
      storeData = this.storage.retrieve(this.enumTabNames.VENDORCONTACT_FILTERS);
    }
    if (this.currentTab == this.enumTabNames.REQUIREMENTS) {
      storeData = this.storage.retrieve(this.enumTabNames.REQUIREMENTS_FILTERS);
    }
    if (this.currentTab == this.enumTabNames.PARTLIST) {
      storeData = this.storage.retrieve(this.enumTabNames.PARTLIST_FILTERS);
    }
    if (this.currentTab == this.enumTabNames.VENDOR_PART_LIBRAY) {
      storeData = this.storage.retrieve(this.enumTabNames.VENDORPARTLIBRAY_FILTERS)
    }
    if (this.currentTab == this.enumTabNames.OEM_EXCESS_MANAGER) {
      storeData = this.storage.retrieve(this.enumTabNames.OEMEXCESSMANAGER_FILTERS)
    }

    let dropDowns = storeData?.allDropDowns
    storeData.companyFilterResponse = storeData?.companyFilterResponse?.filter(value => !(value.labelName === item.labelName && value.id === item.id));
    this.selectFilterOptionlist.filter(value => !(value.labelName === item.labelName && value.id === item.id))

    // removing data from filterList that we use in grid api

    if (item.labelName == this.enumItemLablesNames.CONTACTEDDATE) {
      storeData.companyFilterList.fromDate = '';
      storeData.allDropDowns.fromDate = '';
    }
    if (item.labelName == this.enumItemLablesNames.ARCHIVED) {
      storeData.companyFilterList.archived = false
      storeData.allDropDowns.archived = false
    }
    if (item.labelName == this.enumItemLablesNames.AVL) {
      if (!storeData.allDropDowns?.navl) {
        storeData.allDropDowns.avlId = storeData.companyFilterList.avlId = 0;
      }

      if (storeData.allDropDowns?.navl) {
        storeData.allDropDowns.avlId = storeData.companyFilterList.avlId = 2
      }
      storeData.companyFilterList.avl = false
      storeData.allDropDowns.avl = false
    }
    if (item.labelName == this.enumItemLablesNames.NAVL) {

      if (!storeData.allDropDowns?.avl) {
        storeData.allDropDowns.avlId = storeData.companyFilterList.avlId = 0
      }

      if (storeData.allDropDowns?.avl) {
        storeData.allDropDowns.avlId = storeData.companyFilterList.avlId = 1
      }
      storeData.companyFilterList.navl = false
      storeData.allDropDowns.navl = false
    }
    // if (item.labelName == "AVL" || item.labelName == 'NAVL') {
    //   storeData.companyFilterList.AVLId = 2
    //   storeData.allDropDowns.AVLId = 2
    // }
    if (item.labelName == this.enumItemLablesNames.EXCLUDEDFROM_VENDOR_LIST) {
      storeData.companyFilterList.excludedFromVendorlist = false
      storeData.allDropDowns.excludedFromVendorlist = false
    }

    if (item.labelName == this.enumItemLablesNames.ACTIVE) {
      storeData.activeList[0].isActive = false;
      if (storeData.activeList[1].isActive) {
        storeData.companyFilterList.companyStatusId = 0
      } else {
        storeData.companyFilterList.companyStatusId = 2
      }
    }
    if (item.labelName == this.enumItemLablesNames.INACTIVE) {
      storeData.activeList[1].isActive = false;
      if (storeData.activeList[0].isActive) {
        storeData.companyFilterList.companyStatusId = 1
      } else {
        storeData.companyFilterList.companyStatusId = 2
      }
    }
    if (item.labelName == this.enumItemLablesNames.RATING) {
      storeData.allDropDowns.endRating = 0;
      storeData.allDropDowns.startRating = 0;
      storeData.companyFilterList.endRating = 0;
      storeData.companyFilterList.startRating = 0;
    }
    if (item.labelName == this.enumItemLablesNames.ALT_SALESPERSON) {
      storeData.allDropDowns.altSalesPersonList =
        dropDowns?.altSalesPersonList?.filter(value => value.name != item.name)
      storeData.companyFilterList.altSalesPersonList =
        storeData?.companyFilterList?.altSalesPersonList.replace(item.id, '')
          .replace(/,+/g, ',')
          .replace(/^,|,$/g, '');
    }

    if (item.labelName == this.enumItemLablesNames.BUYERREP) {
      storeData.allDropDowns.buyerRepList =
        dropDowns.buyerRepList?.filter(value => value.name != item.name)
      storeData.companyFilterList.buyerRepList =
        storeData?.companyFilterList?.buyerRepList?.replace(item.id, '')
          .replace(/,+/g, ',')
          .replace(/^,|,$/g, '');
    }
    if (item.labelName == this.enumItemLablesNames.COUNTRY) {
      storeData.allDropDowns.countryList =
        dropDowns?.countryList?.filter(value => value.name != item.name)
      storeData.companyFilterList.countryList =
        storeData?.companyFilterList?.countryList.replace(item.id, '')
          .replace(/,+/g, ',')
          .replace(/^,|,$/g, '');
    }
    if (item.labelName == this.enumItemLablesNames.INDUSTRY) {
      storeData.allDropDowns.industryList =
        dropDowns.industryList.filter(value => value.name != item.name)
      storeData.companyFilterList.industryList =
        storeData.companyFilterList.industryList.replace(item.id, '')
          .replace(/,+/g, ',')
          .replace(/^,|,$/g, '');
    }

    if (item.labelName == this.enumItemLablesNames.MANUFACTURER) {
      storeData.allDropDowns.manufacturerList =
        dropDowns.manufacturerList.filter(value => value.name != item.name)
      storeData.companyFilterList.manufacturerList =
        storeData.companyFilterList.manufacturerList.replace(item.id, '')
          .replace(/,+/g, ',')
          .replace(/^,|,$/g, '');
    }

    if (item.labelName == this.enumItemLablesNames.INTEND_TO_BUY) {
      storeData.allDropDowns.prospectScoreList =
        dropDowns.prospectScoreList.filter(value => value.name != item.name)
      storeData.companyFilterList.prospectScoreList =
        storeData.companyFilterList.prospectScoreList.replace(item.id, '')
          .replace(/,+/g, ',')
          .replace(/^,|,$/g, '');
    }
    if (item.labelName == this.enumItemLablesNames.LEAD) {
      storeData.allDropDowns.leadScoreList =
        dropDowns.leadScoreList.filter(value => value.name != item.name)
      storeData.companyFilterList.leadScoreList =
        storeData.companyFilterList.leadScoreList.replace(item.id, '')
          .replace(/,+/g, ',')
          .replace(/^,|,$/g, '');
    }

    if (item.labelName == this.enumItemLablesNames.NAICS_CODE) {
      storeData.allDropDowns.naicsCodeList =
        dropDowns.naicsCodeList.filter(value => value.name != item.name)
      storeData.companyFilterList.naicsCodeList =
        storeData.companyFilterList.naicsCodeList.replace(item.name, '')
          .replace(/,+/g, ',')
          .replace(/^,|,$/g, '');
    }
    if (item.labelName == this.enumItemLablesNames.SALESPERSON) {
      storeData.allDropDowns.salesPersonList =
        dropDowns.salesPersonList.filter(value => value.name != item.name)
      storeData.companyFilterList.salesPersonList =
        storeData.companyFilterList.salesPersonList.replace(item.id, '')
          .replace(/,+/g, ',')
          .replace(/^,|,$/g, '');
    }
    if (item.labelName == this.enumItemLablesNames.SCOPE) {
      storeData.allDropDowns.scopeList =
        dropDowns.scopeList.filter(value => value.name != item.name)
      storeData.companyFilterList.scopeList =
        storeData.companyFilterList.scopeList.replace(item.id, '')
          .replace(/,+/g, ',')
          .replace(/^,|,$/g, '');
    }
    if (item.labelName == this.enumItemLablesNames.TIMEZONE_LIST) {
      storeData.allDropDowns.timeZoneList =
        dropDowns.timeZoneList.filter(value => value.name != item.name)

      storeData.companyFilterList.timeZoneList =
        storeData.companyFilterList.timeZoneList.replace(item.id, '')
          .replace(/,+/g, ',')
          .replace(/^,|,$/g, '');
    }
    if (item.labelName == this.enumItemLablesNames.SIC_CODE) {
      storeData.allDropDowns.sicCodeList =
        dropDowns.sicCodeList.filter(value => value.name != item.name)
      storeData.companyFilterList.sicCodeList =
        storeData.companyFilterList.sicCodeList.replace(Number(item.name), '')
          .replace(/,+/g, ',')
          .replace(/^,|,$/g, '');
    }
    if (item.labelName == this.enumItemLablesNames.STAGE_STATUS) {
      storeData.allDropDowns.stageStatusList =
        dropDowns.stageStatusList.filter(value => value.name != item.name)

      storeData.companyFilterList.stageStatusList =
        storeData.companyFilterList.stageStatusList.replace(item.id, '')
          .replace(/,+/g, ',')
          .replace(/^,|,$/g, '');
    }
    if (item.labelName == this.enumItemLablesNames.STATE) {
      storeData.allDropDowns.stateList =
        dropDowns.stateList.filter(value => value.name != item.name)
      storeData.companyFilterList.stateList =
        storeData.companyFilterList.stateList.replace(item.id, '')
          .replace(/,+/g, ',')
          .replace(/^,|,$/g, '');
    }
    if (item.labelName == this.enumItemLablesNames.TAGS) {
      storeData.allDropDowns.tagsList =
        dropDowns.tagsList?.filter(value => value.name != item.name)
      storeData.companyFilterList.tagsList =
        storeData.companyFilterList.tagsList.replace(item.id, '')
          .replace(/,+/g, ',')
          .replace(/^,|,$/g, '');
    }

    if (item.labelName == this.enumItemLablesNames.CLASS) {
      storeData.allDropDowns.classList =
        dropDowns.classList.filter(value => value.name != item.name)
      storeData.companyFilterList.classList =
        storeData.companyFilterList.classList.replace(item.id, '')
          .replace(/,+/g, ',')
          .replace(/^,|,$/g, '');
    }
    if (item.labelName == this.enumItemLablesNames.VENDOR_TYPE) {
      storeData.allDropDowns.vendorTypeList =
        dropDowns.vendorTypeList.filter(value => value.name != item.name)
      storeData.companyFilterList.vendorTypeList =
        storeData.companyFilterList.vendorTypeList.replace(item.id, '')
          .replace(/,+/g, ',')
          .replace(/^,|,$/g, '');
    }

    if (item.labelName == this.enumItemLablesNames.PARTLIST_TAG) {
      storeData.allDropDowns.partTagsList =
        dropDowns.partTagsList?.filter(value => value.name != item.name)
      storeData.companyFilterList.partTagsList =
        storeData.companyFilterList.partTagsList.replace(item.id, '')
          .replace(/,+/g, ',')
          .replace(/^,|,$/g, '');
    }


    if (item.labelName == LablesNames.LABEL_CATEGORY_GROUP) {
      storeData.allDropDowns.categoryGroupList =
        dropDowns.categoryGroupList?.filter(value => value.name != item.name)
      storeData.companyFilterList.categoryGroupList =
        storeData.companyFilterList.categoryGroupList.replace(item.id, '')
          .replace(/,+/g, ',')
          .replace(/^,|,$/g, '');
    }

    if (item.labelName == LablesNames.LABEL_PARENT_CATEGORY) {
      storeData.allDropDowns.parentCategoryGroupList =
        dropDowns.parentCategoryGroupList.filter(value => value.name != item.name)
      storeData.companyFilterList.parentCategoryGroupList =
        storeData.companyFilterList.parentCategoryGroupList.replace(item.id, '')
          .replace(/,+/g, ',')
          .replace(/^,|,$/g, '');
    }

    if (item.labelName == LablesNames.LABEL_CATEGORY) {
      storeData.allDropDowns.inventoryCategoryList =
        dropDowns.inventoryCategoryList.filter(value => value.name != item.name)
      storeData.companyFilterList.inventoryCategoryList =
        storeData.companyFilterList.inventoryCategoryList?.replace(item.id, '')
          .replace(/,+/g, ',')
          .replace(/^,|,$/g, '');
    }

    if (item.labelName == LablesNames.LABEL_SUB_CATEGORY) {
      storeData.allDropDowns.subCategoryList =
        dropDowns.subCategoryList.filter(value => value.name != item.name)
      storeData.companyFilterList.subCategoryList =
        storeData.companyFilterList.subCategoryList.replace(item.id, '')
          .replace(/,+/g, ',')
          .replace(/^,|,$/g, '');
    }
    if (item.labelName == this.enumItemLablesNames.PARTSTATUS) {
      storeData.allDropDowns.partStatusList =
        dropDowns.partStatusList.filter(value => value.name != item.name)
      storeData.companyFilterList.partStatusList =
        storeData.companyFilterList.partStatusList.replace(item.id, '')
          .replace(/,+/g, ',')
          .replace(/^,|,$/g, '');
    }
    if (item.labelName == this.enumItemLablesNames.OEMEXCESS_COMPANY) {
      storeData.allDropDowns.customerCompanyNameList =
        dropDowns.customerCompanyNameList.filter(value => value.name != item.name)
      storeData.companyFilterList.customerCompanyNameList =
        storeData.companyFilterList.customerCompanyNameList.replace(item.id, '')
          .replace(/,+/g, ',')
          .replace(/^,|,$/g, '');
    }
    if (item.labelName == this.enumItemLablesNames.OEMEXCESS_COMPANY_CONTACT) {
      storeData.allDropDowns.contactNameList =
        dropDowns.partStatusList.filter(value => value.name != item.name)
      storeData.companyFilterList.contactNameList =
        storeData.companyFilterList.contactNameList.replace(item.id, '')
          .replace(/,+/g, ',')
          .replace(/^,|,$/g, '');
    }
    if (item.labelName == this.enumItemLablesNames.VPL_VENDOR) {
      storeData.allDropDowns.vendorNameList =
        dropDowns.vendorNameList.filter(value => value.name != item.name)
      storeData.companyFilterList.vendorNameList =
        storeData.companyFilterList.vendorNameList.replace(item.id, '')
          .replace(/,+/g, ',')
          .replace(/^,|,$/g, '');
    }
    if (item.labelName == this.enumItemLablesNames.VPL_VENDOR_CONTACT) {
      storeData.allDropDowns.vendorContactList =
        dropDowns.vendorContactList.filter(value => value.name != item.name)
      storeData.companyFilterList.vendorContactList =
        storeData.companyFilterList.vendorContactList.replace(item.id, '')
          .replace(/,+/g, ',')
          .replace(/^,|,$/g, '');
    }


    switch (item.labelName) {
      case LablesNames.LABEL_CATEGORY_GROUP:
        storeData.companyFilterList.parentCategoryGroupList = storeData.companyFilterList.inventoryCategoryList = storeData.companyFilterList.subCategoryList = storeData.companyFilterList.categoryGroupList;
        storeData.allDropDowns.parentCategoryGroupList = storeData.allDropDowns.inventoryCategoryList = storeData.allDropDowns.subCategoryList = storeData.allDropDowns.categoryGroupList;
        storeData.companyFilterResponse = storeData.companyFilterResponse.filter(x => x.labelName !== LablesNames.LABEL_PARENT_CATEGORY && x.labelName !== LablesNames.LABEL_CATEGORY && x.labelName !== LablesNames.LABEL_SUB_CATEGORY)
        break;
      case LablesNames.LABEL_PARENT_CATEGORY:
        storeData.companyFilterList.inventoryCategoryList = storeData.companyFilterList.subCategoryList = storeData.companyFilterList.parentCategoryGroupList;
        storeData.allDropDowns.inventoryCategoryList = storeData.allDropDowns.subCategoryList = storeData.allDropDowns.parentCategoryGroupList;
        storeData.companyFilterResponse = storeData.companyFilterResponse.filter(x => x.labelName !== LablesNames.LABEL_CATEGORY && x.labelName !== LablesNames.LABEL_SUB_CATEGORY)
        break;
      case LablesNames.LABEL_CATEGORY:
        storeData.companyFilterList.subCategoryList = storeData.companyFilterList.inventoryCategoryList;
        storeData.allDropDowns.subCategoryList = storeData.allDropDowns.inventoryCategoryList;
        storeData.companyFilterResponse = storeData.companyFilterResponse.filter(x => x.labelName !== LablesNames.LABEL_SUB_CATEGORY)
        break;
    }

    if (this.currentTab == this.enumTabNames.COMPANIES) {
      this.storage.store(this.enumTabNames.COMPANIES_FILTERS, storeData)
    }
    if (this.currentTab == this.enumTabNames.LEADS) {
      this.storage.store(this.enumTabNames.LEADS_FILTERS, storeData)
    }
    if (this.currentTab == this.enumTabNames.CUSTOMERS) {
      this.storage.store(this.enumTabNames.CUSTOMERS_FILTERS, storeData)
    }
    if (this.currentTab == this.enumTabNames.PROSPECTS) {
      this.storage.store(this.enumTabNames.PROSPECTS_FILTERS, storeData)
    }
    if (this.currentTab == this.enumTabNames.CONTACTS) {
      this.storage.store(this.enumTabNames.CONTACTS_FILTERS, storeData)
    }
    if (this.currentTab == this.enumTabNames.VENDOR_LIST) {
      this.storage.store(this.enumTabNames.VENDORLIST_FILTERS, storeData)
    }
    if (this.currentTab == this.enumTabNames.VENDOR_CONTACT) {
      this.storage.store(this.enumTabNames.VENDORCONTACT_FILTERS, storeData)
    }
    if (this.currentTab == this.enumTabNames.REQUIREMENTS) {
      this.storage.store(this.enumTabNames.REQUIREMENTS_FILTERS, storeData)
    }

    if (this.currentTab == this.enumTabNames.PARTLIST) {
      this.storage.store(this.enumTabNames.PARTLIST_FILTERS, storeData)
    }
    if (this.currentTab == this.enumTabNames.VENDOR_PART_LIBRAY) {
      this.storage.store(this.enumTabNames.VENDORPARTLIBRAY_FILTERS, storeData)
    }
    if (this.currentTab == this.enumTabNames.OEM_EXCESS_MANAGER) {
      this.storage.store(this.enumTabNames.OEMEXCESSMANAGER_FILTERS, storeData)
    }
    this.getDataFromStorage()
    // this.getCompanyFilter();
    this.updateClearFilter()
  }

  clearAllFilter() {
    this.crmService.isRating.next(false)
    this.crmService.isActive.next(false)
    this.agGridService.toggleHeaderExpandIcon.next(false)
    if (this.currentTab == this.enumTabNames.COMPANIES) {
      this.storage.removeItem(this.enumTabNames.COMPANIES_FILTERS)
    }
    if (this.currentTab == this.enumTabNames.LEADS) {
      this.storage.removeItem(this.enumTabNames.LEADS_FILTERS)
    }
    if (this.currentTab == this.enumTabNames.CUSTOMERS) {
      this.storage.removeItem(this.enumTabNames.CUSTOMERS_FILTERS)
    }
    if (this.currentTab == this.enumTabNames.PROSPECTS) {
      this.storage.removeItem(this.enumTabNames.PROSPECTS_FILTERS)
    }
    if (this.currentTab == this.enumTabNames.CONTACTS) {
      this.storage.removeItem(this.enumTabNames.CONTACTS_FILTERS)
    }
    if (this.currentTab == this.enumTabNames.VENDOR_LIST) {
      this.storage.removeItem(this.enumTabNames.VENDORLIST_FILTERS);
    }
    if (this.currentTab == this.enumTabNames.VENDOR_CONTACT) {
      this.storage.removeItem(this.enumTabNames.VENDORCONTACT_FILTERS);
    }

    if (this.currentTab == this.enumTabNames.PARTLIST) {
      this.storage.removeItem(this.enumTabNames.PARTLIST_FILTERS);
    }
    if (this.currentTab == this.enumTabNames.VENDOR_PART_LIBRAY) {
      this.storage.removeItem(this.enumTabNames.VENDORPARTLIBRAY_FILTERS);
    }
    if (this.currentTab == this.enumTabNames.OEM_EXCESS_MANAGER) {
      this.storage.removeItem(this.enumTabNames.OEMEXCESSMANAGER_FILTERS);
    }
    this.getDataFromStorage()

    if (this.selectFilterOptionlist.length != 0 || this.paginationBaseModel.searchText != '') {
      this.selectFilterOptionlist.length
      this.paginationBaseModel.searchText = ''
      // this.getCompanyFilter();
      this.updateClearFilter()
    }
    if (this.currentTab == this.enumTabNames.COMPANIES && this.paginationBaseModel.stage != 'All') {
      this.paginationBaseModel.stage = 'All'
      this.updateClearFilter()
      // this.getCompanyFilter();
    }
    if (this.currentTab == this.enumTabNames.PARTLIST && this.paginationBaseModel.stage != 'All') {
      this.paginationBaseModel.stage = 'All'
      this.updateClearFilter()
      // this.getCompanyFilter();
    }
    if (this.currentTab == this.enumTabNames.VENDOR_PART_LIBRAY && this.paginationBaseModel.stage != 'All') {
      this.paginationBaseModel.stage = 'All'
      this.updateClearFilter()
    }
    if (this.currentTab == this.enumTabNames.OEM_EXCESS_MANAGER && this.paginationBaseModel.stage != 'All') {
      this.paginationBaseModel.stage = 'All'
      this.updateClearFilter()
    }
  }
  openAddRequirement(label) {
    const modalOption: NgbModalOptions = {
      centered: true,
      backdrop: "static",
      keyboard: false,
      size: 'xl',
      // windowClass: "addCompanyPopUP",
    };
    const modalRef = this.modalService.open(AddRequirementComponent, modalOption);
    modalRef.componentInstance.stagesName = this.paginationBaseModel.stage;
    modalRef.componentInstance.headingsNames = label ?? this.buttonName;
  }
  openAddEditCompanyModal() {
    const modalOption: NgbModalOptions = {
      centered: true,
      backdrop: "static",
      keyboard: false,
      // size:'xl',
      windowClass: "addCompanyPopUP",
    };
    const modalRef = this.modalService.open(AddCompanyComponent, modalOption);
    modalRef.componentInstance.stagesName = this.paginationBaseModel.stage;
    modalRef.componentInstance.headingsNames = this.buttonName;
    if (this.buttonName == 'Add Company') {
      this.companiesService.nextTab.next(false)
    }
  }
  openMailingListModal() {
    if (this.selectedData.length != 0) {
      const modalRef = this.modalService.open(AddMailingListComponent, {
        centered: true,
        windowClass: "resetPassword",
        keyboard: false,
        backdrop: 'static',
        size: "sm",
      });
      modalRef.componentInstance.dataList = this.selectedData;
      modalRef.result.then((result) => {
        if (result) {
          this.agGridService.setPaginationData(this.paginationBaseModel);
        }
      });
    }

  }
  openAssignModal() {
    if (this.selectedData.length != 0) {
      const modalRef = this.modalService.open(AssignComponent, {
        centered: true,
        windowClass: "resetPassword",
        keyboard: false,
        backdrop: 'static',
        size: "md",
      });
      modalRef.componentInstance.companyIds = this.companyID;
      modalRef.result.then((result) => {
        if (result) {
          this.agGridService.setPaginationData(this.paginationBaseModel);
        }
      });
    }
  }

  //#region delete
  open_DeleteModal() {
    // opem confirm model  delete company
    const modalOption: NgbModalOptions = {
      centered: false,
      backdrop: "static",
      keyboard: false,
      windowClass: "markAsActiveInactive",
    };
    if (this.selectedData.length != 0) {
      const modalRef = this.modalService.open(
        CommonModelPopUpComponent,
        modalOption
      );
      modalRef.componentInstance.title = this.enumPopUpTitles.DELETE;
      let companyName = this.companyName[1] != undefined ? ", " + this.companyName[1] : "";
      modalRef.componentInstance.fullName = `${this.companyName[0]}${companyName} ${this.companyName.length > 2 ? "&" + " " + (this.companyName.length - 2 + " ") + "others" : ""} `;

      if (this.currentTab == this.enumTabNames.CONTACTS || this.currentTab == this.enumTabNames.VENDOR_CONTACT) {
        let contactName = this.vendorContactName[1] != undefined ? ", " + this.vendorContactName[1] : "";
        modalRef.componentInstance.fullName = `${this.vendorContactName[0]}${contactName} ${this.vendorContactName.length > 2 ? "&" + " " + (this.vendorContactName.length - 2 + " ") + "others" : ""} `;

      }
      modalRef.componentInstance.currentTab = this.currentTab;
      modalRef.componentInstance.pageType = this.currentTab == this.enumTabNames.VENDOR_LIST ? 'vendor' : this.currentTab == this.enumTabNames.CONTACTS ? 'contact' : this.currentTab == this.enumTabNames.VENDOR_CONTACT ? 'vendor contact' : "company";
      modalRef.componentInstance.delPopupforAdmin.subscribe((res) => {
        if (res) {

          if (this.currentTab == this.enumTabNames.CONTACTS || this.currentTab == this.enumTabNames.VENDOR_CONTACT) {
            this.deleteContact();
          } else {
            this.deleteCompanyOnConfirm();
          }
        }
      });
    }
  }
  openDeleteModal() {
    const modalOption: NgbModalOptions = {
      centered: false,
      backdrop: "static",
      keyboard: false,
      windowClass: "markAsActiveInactive",
    };
    if (this.selectedData.length != 0) {
      const modalRef = this.modalService.open(
        CommonModelPopUpComponent,
        modalOption
      );
      modalRef.componentInstance.title = this.enumPopUpTitles.DELETE;
      let name = this.selectedData?.map((items) => { return items.mpn; });

      let companyName = name[1] != undefined ? ", " + name[1] : "";
      modalRef.componentInstance.fullName = `${name[0]}${companyName} ${name.length > 2 ? "&" + " " + (name.length - 2 + " ") + "others" : ""} `;
      modalRef.componentInstance.currentTab = this.currentTab;
      modalRef.componentInstance.pageType = "part";
      modalRef.componentInstance.delPopupforAdmin.subscribe((res) => {
        if (res) {
          let ID = this.selectedData?.map((items) => { return items.id; })
          let reqData = { ids: ID ?? [] }
          this.partsListService.deleteParts(reqData).subscribe((res) => {
            if (res.isSuccess == true) {
              this.gridInfo?.api?.updateRowData({ remove: this.selectedData });
              this.sendDataService.setDeletedMesage(res);
              this.tabsService.deletedTabByList(ID);
              this.afterDeleteSetPagination()
            }
          });
        }
      });
    }

  }
  // delte company
  deleteCompanyOnConfirm() {
    this.deleteCompanyModel.id = this.companyID;
  this.deleteCompanyModel.isVendor = (this.currentTab === this.enumTabNames.VENDOR_LIST);
    // this.deleteCompanyModel.userId = this.userID;
    this.crmService.deleteCompany(this.deleteCompanyModel).subscribe((res) => {
      if (res.isSuccess == true) {
        this.gridInfo?.api?.updateRowData({ remove: this.selectedData });
        this.sendDataService.setDeletedMesage(res);
        this.tabsService.deletedTabByList(this.deleteCompanyModel.id);
        this.afterDeleteSetPagination()
      }
    });
  }
  // delte contact
  deleteContact() {
    this.deleteContactModel.ids = this.contactID;
    this.deleteContactModel.isVendorContact = (this.currentTab === this.enumTabNames.VENDOR_CONTACT);
    // this.deleteContactModel.userId = this.userID;
    this.crmService.deleteContact(this.deleteContactModel).subscribe((res) => {
      if (res.isSuccess == true) {
        this.gridInfo?.api?.updateRowData({ remove: this.selectedData });
        this.sendDataService.setDeletedMesage(res);
        this.tabsService.deletedTabByList(this.deleteContactModel.ids);
        this.afterDeleteSetPagination()
      }
    });
  }
  //#endregion

  // delete company-recycle bin & contact-recycle bin start

  restore(currentTab) {
    const modalOption: NgbModalOptions = {
      centered: true,
      backdrop: "static",
      keyboard: false,
      windowClass: 'resetPassword'
    }
    if (this.selectedData.length != 0) {
      const modalRef = this.modalService.open(CommonModelPopUpComponent, modalOption);

      if (currentTab == this.enumTabNames.COMPANY_RECYCLEBIN) {

        let companyName = this.companyName[1] != undefined ? ", " + this.companyName[1] : "";
        modalRef.componentInstance.fullName = `${this.companyName[0]} ${companyName} ${this.companyName.length > 2 ? "&" + " " + (this.companyName.length - 2 + " ") + "others" : ""} `;
        modalRef.componentInstance.title = 'company record';
        modalRef.result.then((result) => {
          if (result) {
            this.RestoreCompany();
          }
        });
      } else {
        let contactName = this.vendorContactName[1] != undefined ? ", " + this.vendorContactName[1] : "";
        modalRef.componentInstance.fullName = `${this.vendorContactName[0]} ${contactName} ${this.vendorContactName.length > 2 ? "&" + " " + (this.vendorContactName.length - 2 + " ") + "others" : ""} `;
        modalRef.componentInstance.title = 'contact';
        modalRef.result.then((result) => {
          if (result) {
            this.RestoreContact();
          }
        });
      }
    }
  }


  approveDeletion(currentTab) {
    const modalOption: NgbModalOptions = {
      centered: true,
      backdrop: "static",
      keyboard: false,
      windowClass: 'resetPassword'
    }
    if (this.selectedData.length != 0) {
      const modalRef = this.modalService.open(CommonModelPopUpComponent, modalOption);

      if (currentTab == this.enumTabNames.COMPANY_RECYCLEBIN) {
        let companyName = this.companyName[1] != undefined ? ", " + this.companyName[1] : "";
        modalRef.componentInstance.fullName = `${this.companyName[0]} ${companyName} ${this.companyName.length > 2 ? "&" + " " + (this.companyName.length - 2 + " ") + "others" : ""} `;
        modalRef.componentInstance.title = 'company';
        modalRef.componentInstance.delPopup.subscribe((res) => {
          if (res) {
            this.DeleteCompanyPermanent();
          }
        });
      } else {
        let contactName = this.vendorContactName[1] != undefined ? ", " + this.vendorContactName[1] : "";
        modalRef.componentInstance.fullName = `${this.vendorContactName[0]} ${contactName} ${this.vendorContactName.length > 2 ? "&" + " " + (this.vendorContactName.length - 2 + " ") + "others" : ""} `;
        modalRef.componentInstance.title = 'contact';
        modalRef.componentInstance.delPopup.subscribe((res) => {
          if (res) {
            this.DeleteContactPermanently();
          }
        });
      }
    }
  }

  DeleteCompanyPermanent() {
    // this.crmService.deleteCompanyPermanently({ ids: this.companyID }).subscribe((res) => {
    //   if (res.isSuccess == true) {
    //     this.agGridService
    //       .getGridApi()
    //       .updateRowData({ remove: this.selectedData });
    //     this.toastr.success(res.message);
    //   }
    // });
  }

  DeleteContactPermanently() {
    // this.crmService.deleteContactPermanently({ ids: this.contactID }).subscribe((res) => {
    //   if (res.isSuccess == true) {
    //     this.agGridService
    //       .getGridApi()
    //       .updateRowData({ remove: this.selectedData });
    //     this.toastr.success(res.message);
    //   }
    // });
  }

  RestoreCompany() {
    this.crmService.restoreCompany({ ids: this.companyID }).subscribe((res) => {
      if (res.isSuccess == true) {
        this.gridInfo?.api?.updateRowData({ remove: this.selectedData });
        this.toastr.success(res.message);
      }
    });
  }

  RestoreContact() {
    this.crmService.restoreContact({ ids: this.contactID }).subscribe((res) => {
      if (res.isSuccess == true) {
        this.gridInfo?.api?.updateRowData({ remove: this.selectedData });
        this.toastr.success(res.message);
      }
    });
  }

  // delete company-recycle bin & contact-recycle bin start
  addViewOfferForm() {
    return
    const data = { id: this.selectedData[0]?.id, viewOffer: true, }
    this.sendDataService.openModalPopup(AddEditOfferComponent, data, 'View Offer', ModalPopupSize.LG, 'add-part-popup').then(
      (resultData) => {
        if (resultData?.confirm) {
          if (this.selectedData?.length) {
            this.selectedData = []
          }
        }
      });
  }

  addNewOffer() {
    const data = {};
    this.sendDataService.openModalPopup(AddEditOfferComponent, data, 'New Offer', ModalPopupSize.LG, 'add-part-popup').then(
      (resultData) => {
        if (resultData?.confirm) {
        }
      }
    );
  }

  showexportList(fileType) {
    this.paginationBaseModel.selectedId = this.companyID;
    if (fileType == "excel") {
      this.paginationBaseModel.exportAsPdf = false;
    }
    if (fileType == "pdf") {
      this.paginationBaseModel.exportAsPdf = true;
    }

    // this.crmService.exportCompany(this.paginationBaseModel).subscribe((res) => {
    //   this.base64 = res.response[0].headerData;

    //   const byteArray = new Uint8Array(
    //     atob(this.base64)
    //       .split("")
    //       .map((char) => char.charCodeAt(0))
    //   );
    //   if (fileType == "pdf") {
    //     this.file = new Blob([byteArray], { type: "application/pdf" });
    //     this.fileName = "Company.pdf";
    //   }
    //   if (fileType == "excel") {
    //     this.file = new Blob([byteArray], {
    //       type: "data:application/octet-stream;base64",
    //     });
    //     this.fileName = "Company.xlsx";
    //   }
    //   const fileURL = URL.createObjectURL(this.file);
    //   let link = document.createElement("a");
    //   link.download = this.fileName;
    //   link.target = "_blank";

    //   // Construct the URI
    //   link.href = fileURL;
    //   document.body.appendChild(link);
    //   link.click();

    //   // Cleanup the DOM
    //   document.body.removeChild(link);
    // });
  }

  // openImportCompany() {
  //   const modalOption: NgbModalOptions = {
  //     centered: true,
  //     backdrop: "static",
  //     keyboard: false,
  //     size: "lg",
  //   };
  //   const modalRef = this.modalService.open(
  //     ImportCompanyComponent,
  //     modalOption
  //   );
  // }

  navigateToImportCompnaies(buttonImport) {
    if (buttonImport === 'Import') {
      const item: Menu = { path: this.enumPath?.IMPORT_COMPANIES, icon: '', title: 'Import Companies', type: 'link' }
      this.tabsService.addTab(item);
      this.router.navigateByUrl(this.enumPath?.IMPORT_COMPANIES);
      this.crmService?.sendImportId.next(1)
    }
    if (buttonImport === 'Import Vendors') {
      const item: Menu = { path: this.enumPath.IMPORT_VENDORS, icon: '', title: 'Import Vendors', type: 'link' }
      this.tabsService.addTab(item);
      this.router.navigateByUrl(this.enumPath.IMPORT_VENDORS);
      this.crmService.sendImportId.next(2)
    }

  }

  //#region pinned functionality
  pinActive(pinned) {

    if (pinned) {
      this.dockService.addFavouriteDocks(
        this.footerIcon,
        pinned,
        this.footerTitle
      );
    }
    if (!pinned) {
      this.dockService.removeFavouriteDocks();
    }
  }




  gettingArray() {
    let buttonSum = 0
    this.buttonWidths = []
    const containerWidth = this.elRef.nativeElement.querySelector('.filterBar').offsetWidth;
    this.show = this.selectFilterOptionlist.length
    setTimeout(() => {
      try {
        this.buttonRefs.some((buttonRef, index) => {
          this.buttonWidths.push({ width: buttonRef.nativeElement.offsetWidth, name: buttonRef.nativeElement.innerText });
          buttonSum = buttonSum + buttonRef.nativeElement.offsetWidth + 10
          if (buttonSum > containerWidth) {
            if (this.width > 1024) {
              this.bigShow = index
            }
            this.showValfirst = index;
            if (containerWidth > 850) {
              this.show = index + this.addToIndex;
              this.finalShow = index
            } else {
              this.finalShow = index
              this.show = index
            }
            if (this.count === 0) {
              this.count = 1;
              this.valueGet = this.show;
            }
            return true;
          }
        });
      } finally {
        if (this.finalShow) {
          if (this.width > 1024) {
            this.show = this.bigShow
          }
          else {
            this.show = this.finalShow
          }
        }
        if (this.toggle) {
          this.show = this.selectFilterOptionlist.length;
        }
        if (buttonSum < containerWidth && this.toggle) {
          this.toggle = false
        }

      }
    }, 10);

  }
  ngAfterView() {
    setTimeout(() => {
      this.gettingArray()
    }, 20);
  }
  showOther() {
    this.show = this.selectFilterOptionlist.length;
    this.toggle = !this.toggle
  }
  seeAllorLess() {
    this.toggle = !this.toggle
    if (this.toggle) {
      this.show = this.selectFilterOptionlist.length;
    } else {
      if (this.width > 1024) {
        this.show = this.bigShow;
      }
      else {
        this.show = this.showValfirst;
      }
    }
  }

  openFavouriteDockPopup(pinned) {
    if (!pinned) {
      const modalOption: NgbModalOptions = {
        centered: false,
        backdrop: "static",
        keyboard: false,
        windowClass: "markAsActiveInactive",
      };
      const modalRef = this.modalService.open(
        CommonModelPopUpComponent,
        modalOption
      );
      modalRef.componentInstance.title = this.enumPopUpTitles.FAVOURITE_DOCKS;
      modalRef.result.then((result) => {
        if (result.confirm) {
          this.pinActive(pinned);
        }
        if (!result.confirm) {
          this.pinned = !this.pinned;
        }
      });
    } else if (pinned) {
      this.pinActive(pinned);
    }
  }

  openAddContactModal() {
    const modalOption: NgbModalOptions = {
      centered: true,
      backdrop: "static",
      keyboard: false,
      // size:'xl',
      windowClass: "addContactPopup",
    };
    const modalRef = this.modalService.open(AddContactComponent, modalOption);
    modalRef.result.then((res) => {
      if (res?.isSuccess == true) {
        this.agGridService.setPaginationData(this.paginationBaseModel);
      }
    })

    // modalRef.componentInstance.stagesName = this.paginationBaseModel.stage;
  }

  open_AddTaskComponent() {
    const modalOption: NgbModalOptions = {
      centered: true,
      backdrop: "static",
      keyboard: false,
      size: "lg",
    };
    const modalRef = this.modalService.open(AddActivityComponent, modalOption);
    modalRef.componentInstance.addActivityTitle = this.footerPath;
    // modalRef.componentInstance.disabledCompany =true;
    // modalRef.componentInstance.disabledContact =true;
    if (this.currentTab == 'vendor-contact' || this.currentTab == 'contacts') {
      modalRef.componentInstance.disabledCompany = true;
      modalRef.componentInstance.disabledContact = this.stringArrayContactID.length == 1 ? false : true;
    } else {
      modalRef.componentInstance.disabledCompany = this.stringArrayCompanyID.length == 1 ? false : true;
      modalRef.componentInstance.disabledContact = this.stringArrayCompanyID.length == 1 ? false : true;
    }
    modalRef.componentInstance.addActivitiesMultipleCompanymodel.companyId = this.stringArrayCompanyID;
    modalRef.componentInstance.addActivitiesMultipleContactmodel.contactId = this.stringArrayContactID
    modalRef.result.then(res => {
      if (res) {
        this.agGridService.setPaginationData(this.paginationBaseModel);
      }
    })
  }
  Unarchive() {
    const modalOption: NgbModalOptions = {
      centered: false,
      backdrop: "static",
      keyboard: false,
      windowClass: "markAsActiveInactive",
    };
    if (this.selectedData.length != 0) {
      const modalRef = this.modalService.open(
        CommonModelPopUpComponent,
        modalOption
      );
      modalRef.componentInstance.title = this.enumPopUpTitles.UNARCHIVED_COMPANIES;
      let companyName = this.companyName[1] != undefined ? ", " + this.companyName[1] : "";
      modalRef.componentInstance.fullName = `${this.companyName[0]}${companyName} ${this.companyName.length > 2 ? "&" + " " + (this.companyName.length - 2 + " ") + "others" : ""} `.trim();
      modalRef.result.then((res) => {
        if (res.confirm == true) {
          this.unArchivedCompanies()
        }
      });

    }
  }
  selectedDataArchive() {
    const modalOption: NgbModalOptions = {
      centered: false,
      backdrop: "static",
      keyboard: false,
      windowClass: "markAsActiveInactive",
    };
    if (this.selectedData.length != 0) {
      const modalRef = this.modalService.open(
        CommonModelPopUpComponent,
        modalOption
      );
      modalRef.componentInstance.title = this.enumPopUpTitles.ARCHIVED_COMPANIES;
      let companyName = this.companyName[1] != undefined ? ", " + this.companyName[1] : "";
      modalRef.componentInstance.fullName = `${this.companyName[0]}${companyName} ${this.companyName.length > 2 ? "&" + " " + (this.companyName.length - 2 + " ") + "others" : ""} `.trim();
      modalRef.result.then((res) => {
        if (res.confirm == true) {
          this.archivedCompanies()
        }
      });
    }

  }
  archivedCompanies() {
    this.deleteCompanyModel.id = this.companyID;
    this.archivedService.archivedCompanies(this.deleteCompanyModel).subscribe((res) => {
      if (res.isSuccess == true) {
        this.gridInfo?.api?.updateRowData({ remove: this.selectedData });
      }
    });

  }
  unArchivedCompanies() {
    this.deleteCompanyModel.id = this.companyID;
    this.archivedService.unArchivedCompanies(this.deleteCompanyModel).subscribe((res) => {
      if (res.isSuccess == true) {
        this.gridInfo?.api?.updateRowData({ remove: this.selectedData });
      }
    });

  }
  closeList() {
    this.showlist = false
    this.dropDownOpen = null
  }
  closeNewList() {
    this.showNewlist = false
  }
  closeMenuList() {
    this.showImportSubmenu = false;
    this.showNewSubmenu = false;
  }
  addiconList: AddiconList[] = [
    { id: 1, name: "Inventory", selected: false },
    { id: 2, name: "Parts", selected: false },
    { id: 3, name: "OEM Excess", selected: false },
    { id: 4, name: "Vendor Parts", selected: false },
    { id: 5, name: "Consignment", selected: false },

  ];
  addNewList: AddiconList[] = [
    { id: 1, name: "Inventory", selected: false },
    { id: 2, name: "Requirement", selected: false },
    { id: 3, name: "Quote", selected: false },
    { id: 4, name: "Sales Order", selected: false },
    { id: 5, name: "Purchase Order", selected: false },
    { id: 6, name: "Consignment", selected: false },
  ];

  index: number;
  selectedItem(index: number, isOemAndVpl = false) {
    const titles = [
      'Inventory',
      'Part',
      'OEM Excess',
      'Vendor Parts',
      'Consignment',
    ];
    this.index = index;
    for (let i = 0; i < this.addiconList.length; i++) {
      if (i === index) {
        this.addiconList[i].selected = true;
        let url = this.enumPath?.IMPORT + `${titles[index].replace(/\s+/g, '')}`
        const item: Menu = { path: url, icon: '', title: `Import ${titles[index]}`, type: 'link' }
        this.tabsService.isOemAndVpl = isOemAndVpl;
        this.tabsService.addTab(item);
        this.router.navigateByUrl(url);
      }
      else {
        this.addiconList[i].selected = false;
      }
    }
  }
  selectedNewItem(index: number) {
    this.index = index;
    for (let i = 0; i < this.addNewList.length; i++) {
      if (i === index) {
        this.addNewList[i].selected = true;
      }
      else {
        this.addNewList[i].selected = false;
      }
    }
    switch (this.index) {
      case 0:
        this.openAddInventoryPopup()
        break;
      case 1:
        this.openAddRequirement('Add Requirement')
        break;
      case 5:
        this.openAddConsignmentPopup()
        break;
    }

  }
  openCloneAddPartPopup(title) {
    const isPartListInfoRoute = this.route.includes(this.routerPath.PARTLISTINFO_ROUTEPATH);
    const urlSegment = isPartListInfoRoute ? this.route?.split('/').pop() : null;
    const data = {
      clone: true,
      selectedId: isPartListInfoRoute ? urlSegment : this.selectedData[0]?.id
    }
    this.sendDataService.openModalPopup(AddEditPartComponent, data, title, ModalPopupSize.LG, 'add-part-popup').then(
      (resultData) => {
        if (resultData.response?.isSuccess) {
          this.selectedData = []
        }
      }
    );
  }


  openAddPartPopup(title) {
    const data = {}
    this.sendDataService.openModalPopup(AddEditPartComponent, data, title, ModalPopupSize.LG, 'add-part-popup').then(
      (resultData) => {
        if (resultData.response?.isSuccess) {
          // this.refreshInventoryInfoEvent.emit();
        }
      }
    );
  }
  openAddInventoryPopup() {
    const data = {
      selectedData: this.selectedData,
      disableField: true
    }
    this.sendDataService.openModalPopup(AddEditInventoryComponent, data, 'Add Inventory', ModalPopupSize.LG, 'add-part-popup').then(
      (resultData) => {
        if (resultData) {
          if (resultData.success) {

          }
        }
      }
    );
  }
  openVendorPartActivePopup() {
    let title;
    let status;
    let vendorOemId
    switch (this.router.url) {
      case this.routerPath.VENDOR_PARTS_LIBRARY:
        title = this.enumPopUpTitles.VENDOR_PART_ACTIVE;
        status = 'active vendor parts';
        vendorOemId = VplOemId.VPL
        break;
      case this.routerPath.OEM_EXCESS:
        title = this.enumPopUpTitles.LINE_ACTIVE;
        status = 'active lines';
        vendorOemId = VplOemId.OEM
        break;
    }
    const data = {
      selectedData: this.selectedData?.map((items) => { return items.id; }),
      vendorOemId: vendorOemId
    }
    this.sendDataService.openModalPopup(CommonModelPopUpComponent, data, title, ModalPopupSize.MD, 'markAsActiveInactive', false, false).then(
      (resultData) => {
        if (resultData.confirm) {
          if (!resultData?.res?.response?.vendorIsActive) {
            this.openErrorPopup(status);
          } else {
            this.agGridService.setPaginationData(this.paginationBaseModel);
            this.selectedData = []
          }
        }
      }
    );
  }
  openExpireVendorPartPopup() {
    let title;
    let status;
    let vendorOemId
    switch (this.router.url) {
      case this.routerPath.VENDOR_PARTS_LIBRARY:
        title = this.enumPopUpTitles.EXPIRE_VENDOR_PART;
        status = 'expired vendor parts';
        vendorOemId = VplOemId.VPL
        break;
      case this.routerPath.OEM_EXCESS:
        title = this.enumPopUpTitles.EXPIRE_LINE;
        status = 'inactive lines';
        vendorOemId = VplOemId.OEM
        break;
    }

    const data = {
      selectedData: this.selectedData?.map((items) => { return items.id; }),
      vendorOemId: vendorOemId
    }
    this.sendDataService.openModalPopup(CommonModelPopUpComponent, data, title, ModalPopupSize.MD, 'markAsActiveInactive', false,false).then(
      (resultData) => {
        if (resultData.confirm) {
          if (!resultData?.res?.response?.vendorIsActive) {
            this.openErrorPopup(status);
          } else {
            this.agGridService.setPaginationData(this.paginationBaseModel);
            this.selectedData = []
          }
        }

      }
    );
  }
  openErrorPopup(status) {
    const data = { status: status }
    this.sendDataService.openModalPopup(CommonModelPopUpComponent, data, this.enumPopUpTitles.ERROR, ModalPopupSize.MD, 'error-popup markAsActiveInactive', false, false).then(
      (resultData) => {
        if (resultData) {
          if (resultData.success) {

          }
        }
      }
    );
  }
  openAddVendorPartPopup() {
    const data = {
      OEMExcessPopup: true
    }
    this.sendDataService.openModalPopup(AddEditVendorPartComponent, data, 'Add OEM Excess', ModalPopupSize.LG, 'add-part-popup').then(
      (resultData) => {
        if (resultData.confirm) {
          this.agGridService.setPaginationData(this.paginationBaseModel)
        }
      }
    );
  }
  openRequestvendorpopup() {
    const data = {}
    this.sendDataService.openModalPopup(RequestVendorPopupComponent, data, 'Request Vendor Parts List Update', ModalPopupSize.LG, 'vpl-popup').then(
      (resultData) => {
        if (resultData?.success) {
          this.sendDataService.vendorListRefresh$.next();
        }
      }
    );
  }
  openAddVPLPopup() {
    const data = {}
    this.sendDataService.openModalPopup(AddEditVendorPartComponent, data, 'Add Vendor Part', ModalPopupSize.LG, 'add-part-popup').then(
      (resultData) => {
        if (resultData?.confirm) {
          if (this.selectedData?.length) {
            this.selectedData = []
          }
          this.agGridService.setPaginationData(this.paginationBaseModel)
        }
      }
    );
  }
  viewOffer() {
    const data = {
      viewOffer: true,
      offerNumber: '1232124X3232',
      dateCreated: '12/01/2024',
      createdBy: 'John Doe'
    }
    this.sendDataService.openModalPopup(AddEditOfferComponent, data, 'View Offer', ModalPopupSize.LG, 'add-part-popup').then(
      (resultData) => {
        if (resultData) {
          if (resultData.success) {

          }
        }
      }
    );
  }

  openAddConsignmentPopup() {
    const data = {
      selectedData: this.selectedData,
      disableField: true
    }
    this.sendDataService.openModalPopup(AddEditConsignmentComponent, data, 'Add Consignment', ModalPopupSize.LG, 'add-part-popup').then(
      (resultData) => {
        if (resultData) {
          if (resultData.success) {

          }
        }
      }
    );
  }
  openViewConsignmentpopup(params) {
    const data = {}
    this.sendDataService.openModalPopup(ViewConsignmentComponent, data, 'Consignment Details', ModalPopupSize.LG, 'add-part-popup').then(
      (resultData) => {
        if (resultData) {
          if (resultData.success) {

          }
        }
      }
    );
  }
  openInventoryLinepopup(params) {
    const data = {
      inventoryLineDetail: true,
    }
    this.sendDataService.openModalPopup(ViewConsignmentComponent, data, 'Inventory Line Details', ModalPopupSize.LG, 'add-part-popup').then(
      (resultData) => {
        if (resultData) {
          if (resultData.success) {

          }
        }
      }
    );
  }


  ngOnDestroy() {
    this.agGridService.tablePaginationData.next(undefined);
    this.agGridService.setPaginationData(undefined);
    if (this.switchSubscription != undefined) {
      this.switchSubscription.unsubscribe();
    }
    if (this.starSubscription != undefined) {
      this.starSubscription.unsubscribe();
    }
  }
  toggleDropdown(id: string) {
    this.dropDownOpen = this.dropDownOpen === id ? null : id;
  }

  // @HostListener('document:click',['$event'])
  // handleClickOutside(event:MouseEvent){
  //   const target = event.target as HTMLElement;
  // if (!target.closest('.dropdown-wrapper')) {
  //   this.dropDownOpen = null;
  // }
  // }
  openEditVendor() {
    let data: any = { id: this.selectedData[0]?.id };
    let title
    if (this.route == this.routerPath.OEM_EXCESS) {
      title = 'Edit OEM Excess'
      data = { ...data, OEMExcessPopup: true }
    } else {
      title = 'Edit Vendor Part'
    }
    this.sendDataService.openModalPopup(AddEditVendorPartComponent, data, title, ModalPopupSize.LG, 'add-part-popup').then(
      (resultData) => {
        if (resultData?.confirm) {
          if (this.selectedData?.length) {
            this.selectedData = []
          }
          this.agGridService.setPaginationData(this.paginationBaseModel);
        }
      }
    );
  }
  vplDeleteModal() {
    const modalOption: NgbModalOptions = {
      centered: false,
      backdrop: "static",
      keyboard: false,
      windowClass: "markAsActiveInactive",
    }
    if (this.selectedData?.length) {
      const modalRef = this.modalService.open(CommonModelPopUpComponent, modalOption);
      modalRef.componentInstance.title = this.enumPopUpTitles.DELETE;
      let name = this.selectedData?.map((items) => { return items.mpn; });
      let vplName = name[1] != undefined ? ", " + name[1] : "";
      modalRef.componentInstance.fullName = `${name[0]}${vplName} ${name.length > 2 ? "&" + " " + (name.length - 2 + " ") + "others" : ""} `;
      modalRef.componentInstance.pageType = this.route === this.routerPath?.OEM_EXCESS ? 'OEM Excess' : 'vendor part library';
      modalRef.componentInstance.delPopupforAdmin.subscribe((res) => {
        if (res) {
          let ID = this.selectedData?.map((items) => { return items.id; })
          let reqData = { ids: ID ?? [] }
          const deleteObservable = this.route === this.routerPath?.OEM_EXCESS
            ? this.oemExcessService.deleteOemParts(reqData)
            : this.vplService.deleteVendorParts(reqData);
          deleteObservable.subscribe((res) => {
            if (res?.isSuccess) {
              this.gridInfo?.api?.updateRowData({ remove: this.selectedData });
              this.sendDataService.setDeletedMesage(res);
              this.tabsService.deletedTabByList(ID);
              this.afterDeleteSetPagination()
            }
          });
        }
      })
    }
  }

  buttonNewOutputEvent(event) {
    switch (event?.data?.id) {
      case 1: this.addNewOffer();
        break;
      case 2:
        event.data.name === "Vendor Part" ? this.openAddVPLPopup() : this.openAddVendorPartPopup()
        break;
    }
  }

  buttonLineStatusEvent(event) {
    switch (event?.data?.id) {
      case 1:
        this.openVendorPartActivePopup();
        break;
      case 2:
        this.openExpireVendorPartPopup();
        break;
    }
  }

  onRequestClick(event) {
    switch (event.data.id) {
      case 1:
        this.addViewOfferForm();
        break;
      case 2:
        this.openEditVendor();
        break;
    }
  }
  afterDeleteSetPagination() {
    if (this.agGridService.totalPages) {
      let isHeaderCheckboxChecked = this.gridInfo?.api?.getDisplayedRowCount() === this.gridInfo?.api?.getSelectedNodes()?.length;
      if (isHeaderCheckboxChecked) { this.paginationBaseModel.pageNumber = 1 }
      this.agGridService.setPaginationData(this.paginationBaseModel);
    }
  }

  getSearchPlaceholder(): string {
    if (this.currentTab === this.enumTabNames.VENDOR_LIST) {
      return 'Search by vendor name…';
    }
    if (this.currentTab === this.enumTabNames.REQUIREMENTS ||
      this.route === this.routerPath.OEM_EXCESS) {
      return 'Search…';
    }
    if (this.currentTab === this.enumTabNames.PARTLIST) {
      return 'Search by MPN, NSN, or IPN…';
    }
    if (this.currentTab === this.enumTabNames.CONTACTS ||
      this.currentTab === this.enumTabNames.CONTACT_RECYCLEBIN ||
      this.currentTab === this.enumTabNames.VENDOR_CONTACT) {
      return 'Search by contact name…';
    }
    if (this.route === this.routerPath.VENDOR_PARTS_LIBRARY) {
      return 'Search Part Number…';
    }
    return 'Search by company name…';
  }

}

